export default {
  RESET_CONTEXT: 'resetContext',
};
